import {combine, createEffect} from 'effector';
import {createGate} from 'effector-react';

import {getCustoms} from 'api/profile/customs';
import {
    createCustomsUser,
    fetchCustomsUsersList,
    unboundCustomsUser,
    updateCustomsUser,
} from 'api/profile/customsUsers';
import {createGridTableModel} from 'core/hooks/grid2.0';
import {rootDomain} from 'core/rootDomain';
import {CustomsUserRow, CustomsPaginationContent, Customs} from 'types/profile';

const domain = rootDomain.createDomain('customsUsersTableDomain');

export const Gate = createGate<{id: string}>('CustomsUsersTableGate');

export const fetchDataFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchCustomsUsersList,
});

export const fetchCustomsFx = domain.createEffect({
    name: 'fetchCustomsFx',
    handler: getCustoms,
});

export const createCustomsUserFx = createEffect({
    name: 'createCustomsUserFx',
    handler: createCustomsUser,
});

export const updateCustomsUserFx = createEffect({
    name: 'updateCustomsUserFx',
    handler: updateCustomsUser,
});

export const unboundCustomsUserFx = createEffect({
    name: 'unboundCustomsUserFx',
    handler: unboundCustomsUser,
});

export const {
    pageNumber$,
    pageNumberChanged,
    pageSize$,
    pageSizeChanged,
    sortings$,
    sortingsChanged,
    sortingsReset,
    defaultSortings,
} = createGridTableModel({
    domain,
});

export const onChangeCustomsUserIdForUnboundConfirmation = domain.createEvent<{
    userId: number | string;
    customsId: number | string;
} | null>();
export const onSetEditUser = domain.createEvent<CustomsUserRow>();

export const customs$ = domain.createStore<Customs | null>(null);
export const data$ = domain.createStore<CustomsPaginationContent<CustomsUserRow> | null>(null);
export const editUserData$ = domain.createStore<CustomsUserRow | null>(null);
export const customsUserIdsForUnboundConfirmation$ = domain.createStore<{
    userId: number | string;
    customsId: number | string;
} | null>(null);

export const searchChanged = domain.createEvent<string>();
export const search$ = domain.createStore('').on(searchChanged, (_, value) => value);

export const customsUsersState$ = combine({
    data: data$,
    pageNumber: pageNumber$,
    pageSize: pageSize$,
    isLoading: fetchDataFx.pending,
});
